// src/pages/financeiro/ContaBancoSearch.js
import React, { useEffect, useState, useRef } from 'react';
import { useContaBanco } from '../../contexts/financeiro/ContaBancoContext';
import { FaSortUp, FaSortDown } from "react-icons/fa";

import ModalTable from '../../components/modalForm/ModalTable';
import LazyLoading from '../../components/modalForm/LazyLoading';

import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalSearchBar from '../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../components/modalForm/ModalActions';
import ModalSelectButton from '../../components/modalForm/ModalSelectButton';

const ContaBancoSearch = ({ show, onHide, onSelectContaBanco }) => {
    const { contasBanco } = useContaBanco(); // Contexto de contas bancárias
    const [filter, setFilter] = useState('');

    const [sortField, setSortField] = useState('id'); // 'id' ou 'descricao'
    const [sortDirection, setSortDirection] = useState('asc'); // 'asc' ou 'desc'
     // Quantidade de itens por página

    const inputRef = useRef(null); // Referência para o input

    useEffect(() => {
        // Limpa campos quando o modal é aberto
        if (show) {
            setFilter('');
             // Reseta para a primeira página ao abrir o modal
            if (inputRef.current) {
                inputRef.current.focus(); // Aplica o foco no input quando o modal abrir
            }
        }
    }, [show]);

    if (!show) return null;

    // Filtra as contas bancárias pela descrição
    const filteredContasBanco = contasBanco.filter(contaBanco =>
        contaBanco.descricaoConta.toLowerCase().includes(filter.toLowerCase())
    );

    // Ordena as contas bancárias de acordo com o campo e direção selecionados
    const sortedContasBanco = filteredContasBanco.sort((a, b) => {
        if (sortField === 'id') {
            return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        } else if (sortField === 'descricaoConta') {
            const descriptionA = a.descricaoConta.toLowerCase();
            const descriptionB = b.descricaoConta.toLowerCase();
            if (descriptionA < descriptionB) return sortDirection === 'asc' ? -1 : 1;
            if (descriptionA > descriptionB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        }
        return 0; // Retorno padrão
    });

    // Divide as contas bancárias em páginas

    // Número total de páginas

    // Funções de navegação

    // Função para alternar a ordenação por campo
    const handleSort = (field) => {
        if (sortField === field) {
            // Se já estiver ordenando pelo mesmo campo, inverte a direção
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc'); // Reseta para 'asc' ao mudar de campo
        }
    };

    // Função para lidar com o clique duplo na linha da tabela
    const handleDoubleClick = (contaBanco) => {
        onSelectContaBanco(contaBanco); // Passa a conta bancária para o método de seleção
        onHide(); // Fecha o modal
    };

    return (
        <ModalContainer show={show} largura="600px" variant="busca" onHide={onHide}>

            <ModalHeader title="Buscar Conta Bancária" onHide={onHide} />
            <ModalBody className="modal-body">
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef} // A referência do input
                        type="text"

                        placeholder="Filtrar por descrição..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>

                <LazyLoading items={sortedContasBanco} resetKey={JSON.stringify([show, filter, sortField, sortDirection])}>
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
                    <thead>
                        <tr>
                            <th className="text-center align-middle" scope="col" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('id')} style={{ fontWeight:'bold', background: 'none', border: 'none' }} type="button">
                                    Id
                                    {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="align-middle" scope="col" style={{ width: '60%' }} aria-sort={sortField === 'descricaoConta' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('descricaoConta')} style={{ fontWeight:'bold', background: 'none', border: 'none' }} type="button">
                                    Descrição
                                    {sortField === 'descricaoConta' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" scope="col" style={{ width: '18%' }}>Selecionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map(contaBanco => (
                            <tr key={contaBanco.id}
                            onDoubleClick={() => handleDoubleClick(contaBanco)} // Manipulador de duplo clique
                            >
                                <td className="text-end align-middle">{contaBanco.id}</td>
                                <td className="align-middle">{contaBanco.descricaoConta}</td>
                                <td className="text-center align-middle modal-select-column">
                                <ModalSelectButton className="btn btn-outline-secondary btn-sm" style={{ padding: '2px 6px' }} onClick={() => onSelectContaBanco(contaBanco)} label={contaBanco.descricaoConta}>{/* Cor cinza escuro */}</ModalSelectButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>
            <ModalFooter className="modal-footer">
                {/* Paginação */}

                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">
                    Fechar
                </ModalActionButton>
            </ModalFooter>

        </ModalContainer>
    );
};

export default ContaBancoSearch;
